<div class="header">
  <math-auth-header [hideLogo]="!authLayoutService.informerContent()" />
</div>

<ng-container
  [ngTemplateOutlet]="authLayoutService.informerContent() || baseContent"
></ng-container>

<ng-template #baseContent>
  <div nz-flex class="base-content" nzAlign="center" nzJustify="center">
    <img class="logo" src="assets/mathema-logo-2.png" alt="Logo" />
  </div>
</ng-template>

<div class="card-content">
  <ng-content></ng-content>
</div>
